// import axios from '@/lib/axios';
import config from './config';

function getListBandwidthPackages(params) {
  return Ajax.get(config.listBandwidthPackages, params);	
}

export {
  getListBandwidthPackages
};


// WEBPACK FOOTER //
// ./src/api/sbw/list/actions.js